import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';

// Furniture/sofa SVG illustrations
function FurnitureIllustration() {
  return (
    <svg viewBox="0 0 420 380" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full max-h-[340px]">
      <ellipse cx="210" cy="340" rx="170" ry="18" fill="rgba(0,0,0,0.08)" />
      <rect x="60" y="220" width="300" height="90" rx="18" fill="#fff" fillOpacity="0.25" />
      <rect x="60" y="220" width="300" height="90" rx="18" stroke="#fff" strokeOpacity="0.5" strokeWidth="1.5" />
      <rect x="70" y="165" width="280" height="68" rx="14" fill="#fff" fillOpacity="0.2" stroke="#fff" strokeOpacity="0.4" strokeWidth="1.5" />
      <rect x="48" y="195" width="38" height="80" rx="10" fill="#fff" fillOpacity="0.2" stroke="#fff" strokeOpacity="0.4" strokeWidth="1.5" />
      <rect x="334" y="195" width="38" height="80" rx="10" fill="#fff" fillOpacity="0.2" stroke="#fff" strokeOpacity="0.4" strokeWidth="1.5" />
      <rect x="90" y="305" width="16" height="28" rx="5" fill="#fff" fillOpacity="0.35" />
      <rect x="154" y="305" width="16" height="28" rx="5" fill="#fff" fillOpacity="0.35" />
      <rect x="250" y="305" width="16" height="28" rx="5" fill="#fff" fillOpacity="0.35" />
      <rect x="314" y="305" width="16" height="28" rx="5" fill="#fff" fillOpacity="0.35" />
      <line x1="210" y1="222" x2="210" y2="308" stroke="#fff" strokeOpacity="0.25" strokeWidth="2" />
      <rect x="310" y="240" width="80" height="8" rx="4" fill="#fff" fillOpacity="0.3" stroke="#fff" strokeOpacity="0.4" strokeWidth="1" />
      <rect x="330" y="248" width="5" height="52" rx="2.5" fill="#fff" fillOpacity="0.3" />
      <rect x="365" y="248" width="5" height="52" rx="2.5" fill="#fff" fillOpacity="0.3" />
      <polygon points="340,200 360,200 355,240 345,240" fill="#fff" fillOpacity="0.25" stroke="#fff" strokeOpacity="0.4" strokeWidth="1" />
      <rect x="348" y="190" width="4" height="12" rx="2" fill="#fff" fillOpacity="0.4" />
      <ellipse cx="350" cy="189" rx="12" ry="5" fill="#fff" fillOpacity="0.2" stroke="#fff" strokeOpacity="0.4" strokeWidth="1" />
      <ellipse cx="350" cy="200" rx="35" ry="20" fill="#fff" fillOpacity="0.06" />
      <rect x="30" y="260" width="10" height="40" rx="3" fill="#fff" fillOpacity="0.3" />
      <ellipse cx="35" cy="248" rx="22" ry="22" fill="#fff" fillOpacity="0.12" stroke="#fff" strokeOpacity="0.3" strokeWidth="1.5" />
      <ellipse cx="22" cy="258" rx="14" ry="14" fill="#fff" fillOpacity="0.1" stroke="#fff" strokeOpacity="0.25" strokeWidth="1" />
      <ellipse cx="50" cy="254" rx="16" ry="14" fill="#fff" fillOpacity="0.1" stroke="#fff" strokeOpacity="0.25" strokeWidth="1" />
      <circle cx="120" cy="130" r="4" fill="#fff" fillOpacity="0.25" />
      <circle cx="290" cy="100" r="3" fill="#fff" fillOpacity="0.2" />
      <circle cx="370" cy="140" r="5" fill="#fff" fillOpacity="0.15" />
      <circle cx="80" cy="160" r="2.5" fill="#fff" fillOpacity="0.3" />
      <circle cx="175" cy="148" r="22" fill="#fff" fillOpacity="0.3" stroke="#fff" strokeOpacity="0.5" strokeWidth="1.5" />
      <path d="M155 170 Q175 160 195 170 L200 230 H150 Z" fill="#fff" fillOpacity="0.2" stroke="#fff" strokeOpacity="0.4" strokeWidth="1" />
      <path d="M150 230 Q140 250 120 255 Q115 270 130 272 Q150 265 155 250 L160 235" fill="#fff" fillOpacity="0.18" stroke="#fff" strokeOpacity="0.35" strokeWidth="1" />
      <path d="M200 230 Q205 250 220 258 Q228 268 218 272 Q205 268 198 255 L194 235" fill="#fff" fillOpacity="0.18" stroke="#fff" strokeOpacity="0.35" strokeWidth="1" />
      <rect x="148" y="210" width="56" height="35" rx="4" fill="#fff" fillOpacity="0.25" stroke="#fff" strokeOpacity="0.4" strokeWidth="1" />
      <rect x="142" y="243" width="68" height="5" rx="2.5" fill="#fff" fillOpacity="0.2" />
      <rect x="152" y="213" width="48" height="28" rx="2" fill="#fff" fillOpacity="0.12" />
      <path d="M195 200 Q210 205 218 213" stroke="#fff" strokeOpacity="0.4" strokeWidth="3" strokeLinecap="round" />
      <path d="M60 228 Q130 224 210 228 Q290 232 360 228" stroke="#fff" strokeOpacity="0.15" strokeWidth="1" fill="none" />
      <path d="M60 240 Q130 236 210 240 Q290 244 360 240" stroke="#fff" strokeOpacity="0.1" strokeWidth="1" fill="none" />
    </svg>
  );
}

function DecorDots() {
  const dots = [
    { x: "12%", y: "15%", size: 60, opacity: 0.07 },
    { x: "82%", y: "8%", size: 100, opacity: 0.05 },
    { x: "70%", y: "80%", size: 80, opacity: 0.07 },
    { x: "5%", y: "70%", size: 50, opacity: 0.08 },
  ];
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {dots.map((d, i) => (
        <div
          key={i}
          className="absolute rounded-full border border-white"
          style={{
            left: d.x, top: d.y,
            width: d.size, height: d.size,
            opacity: d.opacity,
            transform: "translate(-50%, -50%)",
          }}
        />
      ))}
    </div>
  );
}

export default function LoginPage() {
  const [screen, setScreen] = useState('login');
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPass, setShowPass] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [resetToken, setResetToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [recoveredUsername, setRecoveredUsername] = useState('');
  const [showNewPw, setShowNewPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [forgotPurpose, setForgotPurpose] = useState('password');

  const { login } = useAuth();
  const navigate = useNavigate();

  // Organization suspend / expire hone par session se aaya message dikhao
  useEffect(() => {
    const msg = sessionStorage.getItem('org_blocked_message');
    if (msg) { setError(msg); sessionStorage.removeItem('org_blocked_message'); }
  }, []);

  const clearMessages = () => {
    setError('');
    setSuccess('');
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    clearMessages();
    if (!form.username.trim() || !form.password) {
      setError('Please enter your username and password.');
      return;
    }
    setLoading(true);
    try {
      const result = await login(form.username, form.password);
      if (result.success) {
        toast.success('Login successful!');
        navigate(result.role === 'superadmin' ? '/superadmin' : result.role === 'admin' ? '/admin' : '/worker');
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleForgotClick = async (purpose) => {
    clearMessages();
    setForgotPurpose(purpose);
    if (form.username.trim()) {
      setLoading(true);
      try {
        const res = await api.post('/auth/check-email-status', { username: form.username.trim() });
        if (res.data.reason === 'worker') {
          setScreen('worker-contact');
          return;
        }
        if (res.data.reason === 'no_email') {
          setError(res.data.message);
          return;
        }
      } catch (err) {
        console.error('Check email error:', err);
      } finally {
        setLoading(false);
      }
    }
    setScreen('forgot-email-input');
  };

  const handleSendOTP = async (e) => {
    e.preventDefault();
    clearMessages();
    if (!forgotEmail.trim()) {
      setError('Please enter your email address.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/forgot-request', { 
        email: forgotEmail.trim(), 
        purpose: forgotPurpose 
      });
      setSuccess('OTP sent! Check your email.');
      setScreen('otp-verify');
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    clearMessages();
    if (!otp.trim() || otp.length !== 6) {
      setError('Please enter the 6-digit OTP.');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/auth/verify-otp', { 
        email: forgotEmail.trim(), 
        otp: otp.trim() 
      });
      setResetToken(res.data.reset_token);
      if (forgotPurpose === 'username') {
        await handleRecoverUsername(res.data.reset_token);
      } else {
        setScreen('reset-password');
        setSuccess('OTP verified! Set your new password.');
      }
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRecoverUsername = async (token) => {
    try {
      const res = await api.post('/auth/recover-username', { reset_token: token || resetToken });
      setRecoveredUsername(res.data.username);
      setScreen('show-username');
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    clearMessages();
    if (newPassword.length < 4) {
      setError('Password must be at least 4 characters.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { 
        reset_token: resetToken, 
        new_password: newPassword 
      });
      setSuccess('Password reset! Redirecting...');
      setTimeout(() => {
        setScreen('login');
        setNewPassword('');
        setConfirmPassword('');
        setResetToken('');
        setSuccess('');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  };

  const goBackToLogin = () => {
    setScreen('login');
    setError('');
    setSuccess('');
    setOtp('');
    setForgotEmail('');
    setResetToken('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const inputClass = `w-full border-0 border-b-2 border-stone-200 bg-transparent py-3 px-1 text-stone-800 placeholder-stone-400 focus:outline-none focus:border-amber-600 transition-colors duration-200 text-sm`;
  const btnPrimary = `w-full py-3 rounded-xl font-semibold text-white text-sm bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 active:scale-[0.98] transition-all shadow-md shadow-amber-200 disabled:opacity-60 disabled:cursor-not-allowed`;
  const btnSecondary = `text-amber-700 hover:text-amber-900 text-sm font-medium transition-colors underline underline-offset-2`;

  const LeftPanel = () => (
    <div className="relative hidden lg:flex flex-col justify-between overflow-hidden" style={{ background: "linear-gradient(145deg, #c2410c 0%, #ea580c 45%, #d97706 100%)" }}>
      <DecorDots />
      <div className="relative z-10 p-10 pt-12">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M9 22V12h6v10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </div>
          <div>
            <p className="text-white font-bold text-lg">Workshop Manager</p>
            <p className="text-amber-200 text-xs">Wood & Furniture Production</p>
          </div>
        </div>
      </div>
      <div className="relative z-10 flex-1 flex items-center justify-center px-8">
        <FurnitureIllustration />
      </div>
      <div className="relative z-10 p-10 pb-12">
        <h2 className="text-white font-bold text-3xl mb-3">Craft every detail.<br />Track every piece.</h2>
        <p className="text-amber-200 text-sm mb-5">End-to-end production management for your wood & furniture workshop.</p>
        <div className="flex flex-wrap gap-2">
          {["Production Tracking", "Worker Management", "Client Portal"].map(tag => (
            <span key={tag} className="px-3 py-1 rounded-full bg-white/15 text-white text-xs font-medium">{tag}</span>
          ))}
        </div>
      </div>
    </div>
  );

  // LOGIN SCREEN
  if (screen === 'login') {
    return (
      <div className="min-h-screen grid lg:grid-cols-2" style={{ background: "#fafaf8" }}>
        <LeftPanel />
        <div className="flex flex-col justify-center px-8 py-12 sm:px-14 lg:px-16">
          <div className="max-w-sm w-full mx-auto">
            <h1 className="text-4xl font-bold text-stone-900 mb-1">Welcome back</h1>
            <p className="text-stone-400 text-sm mb-10">Sign in to your workspace</p>
            
            <form onSubmit={handleLogin} className="space-y-7">
              <div>
                <label className="block text-xs font-semibold text-stone-500 uppercase mb-2">Username</label>
                <input type="text" className={inputClass} placeholder="Enter username" value={form.username} onChange={e => setForm({...form, username: e.target.value})} disabled={loading} />
              </div>
              <div>
                <label className="block text-xs font-semibold text-stone-500 uppercase mb-2">Password</label>
                <div className="relative">
                  <input type={showPass ? 'text' : 'password'} className={`${inputClass} pr-10`} placeholder="Enter password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} disabled={loading} />
                  <button type="button" onClick={() => setShowPass(!showPass)} className="absolute right-1 top-3 text-stone-300">{showPass ? '🙈' : '👁️'}</button>
                </div>
              </div>
              {error && <div className="flex items-center gap-2 bg-red-50 border border-red-100 px-4 py-3 rounded-xl text-red-600 text-sm"><span>⚠️</span>{error}</div>}
              {success && <div className="flex items-center gap-2 bg-green-50 border border-green-100 px-4 py-3 rounded-xl text-green-700 text-sm"><span>✅</span>{success}</div>}
              <button type="submit" disabled={loading} className={btnPrimary}>{loading ? '🔄 Signing in...' : 'Sign In'}</button>
            </form>
            
            {/* Forgot password/username — temporarily disabled
            <div className="mt-8 pt-6 border-t border-stone-100 flex gap-2 justify-center">
              <button className={btnSecondary} onClick={() => handleForgotClick('password')} disabled={loading}>Forgot password?</button>
              <span className="text-stone-300">·</span>
              <button className={btnSecondary} onClick={() => handleForgotClick('username')} disabled={loading}>Forgot username?</button>
            </div>
            */}

            {/* Default credentials removed */}
          </div>

          {/* ── Powered by Laxman Software ── */}
          <div className="mt-10 pt-6 border-t border-stone-100 text-center">
            <p className="text-[11px] text-stone-400 leading-relaxed">
              Powered by{' '}
              <span className="font-bold text-amber-700">Laxman Software</span>
              {' '}— delivering innovative software solutions,{' '}
              modern websites, and stunning landing pages for businesses and startups.
            </p>
            <p className="text-[11px] text-stone-400 mt-1">
              💡 Custom Development &nbsp;|&nbsp; Web Solutions &nbsp;|&nbsp; Business Automation
            </p>
            <p className="text-[11px] font-semibold text-amber-600 mt-1">
              📞 Contact: 8875448173
            </p>
          </div>
        </div>
      </div>
    );
  }

  // FORGOT EMAIL INPUT
  if (screen === 'forgot-email-input') {
    return (
      <div className="min-h-screen grid lg:grid-cols-2" style={{ background: "#fafaf8" }}>
        <LeftPanel />
        <div className="flex flex-col justify-center px-8 py-12 sm:px-14 lg:px-16">
          <div className="max-w-sm w-full mx-auto">
            <button onClick={goBackToLogin} className="flex items-center gap-1.5 text-stone-400 hover:text-stone-700 text-sm mb-8">← Back</button>
            <h1 className="text-3xl font-bold text-stone-900 mb-2">{forgotPurpose === 'password' ? 'Reset Password' : 'Recover Username'}</h1>
            <p className="text-stone-400 text-sm mb-8">Enter the email linked to your account.</p>
            
            <form onSubmit={handleSendOTP} className="space-y-6">
              <div>
                <label className="block text-xs font-semibold text-stone-500 uppercase mb-2">Email</label>
                <input type="email" className={inputClass} placeholder="your@email.com" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} disabled={loading} autoFocus />
              </div>
              {error && <div className="flex items-center gap-2 bg-red-50 border border-red-100 px-4 py-3 rounded-xl text-red-600 text-sm">⚠️ {error}</div>}
              {success && <div className="flex items-center gap-2 bg-green-50 border border-green-100 px-4 py-3 rounded-xl text-green-700 text-sm">✅ {success}</div>}
              <button type="submit" disabled={loading} className={btnPrimary}>{loading ? '🔄 Sending...' : 'Send Code'}</button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  // OTP VERIFY
  if (screen === 'otp-verify') {
    return (
      <div className="min-h-screen grid lg:grid-cols-2" style={{ background: "#fafaf8" }}>
        <LeftPanel />
        <div className="flex flex-col justify-center px-8 py-12 sm:px-14 lg:px-16">
          <div className="max-w-sm w-full mx-auto">
            <button onClick={() => setScreen('forgot-email-input')} className="flex items-center gap-1.5 text-stone-400 hover:text-stone-700 text-sm mb-8">← Back</button>
            <h1 className="text-3xl font-bold text-stone-900 mb-2">Verify Email</h1>
            <p className="text-stone-400 text-sm mb-8">Enter the 6-digit code sent to {forgotEmail}.</p>
            
            <form onSubmit={handleVerifyOTP} className="space-y-6">
              <input type="text" maxLength="6" inputMode="numeric" value={otp} onChange={e => setOtp(e.target.value.replace(/\D/g, ''))} placeholder="000000" className={`${inputClass} text-center text-2xl tracking-widest font-mono`} autoFocus />
              {error && <div className="flex items-center gap-2 bg-red-50 border border-red-100 px-4 py-3 rounded-xl text-red-600 text-sm">⚠️ {error}</div>}
              {success && <div className="flex items-center gap-2 bg-green-50 border border-green-100 px-4 py-3 rounded-xl text-green-700 text-sm">✅ {success}</div>}
              <button type="submit" disabled={loading || otp.length !== 6} className={btnPrimary}>{loading ? '🔄 Verifying...' : 'Verify'}</button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  // RESET PASSWORD
  if (screen === 'reset-password') {
    return (
      <div className="min-h-screen grid lg:grid-cols-2" style={{ background: "#fafaf8" }}>
        <LeftPanel />
        <div className="flex flex-col justify-center px-8 py-12 sm:px-14 lg:px-16">
          <div className="max-w-sm w-full mx-auto">
            <h1 className="text-3xl font-bold text-stone-900 mb-2">Set New Password</h1>
            <p className="text-stone-400 text-sm mb-8">Choose a strong password.</p>
            
            <form onSubmit={handleResetPassword} className="space-y-6">
              <div>
                <label className="block text-xs font-semibold text-stone-500 uppercase mb-2">New Password</label>
                <div className="relative">
                  <input type={showNewPw ? 'text' : 'password'} className={`${inputClass} pr-10`} placeholder="Min 4 chars" value={newPassword} onChange={e => setNewPassword(e.target.value)} disabled={loading} autoFocus />
                  <button type="button" onClick={() => setShowNewPw(!showNewPw)} className="absolute right-1 top-3 text-stone-300">{showNewPw ? '🙈' : '👁️'}</button>
                </div>
              </div>
              <div>
                <label className="block text-xs font-semibold text-stone-500 uppercase mb-2">Confirm</label>
                <input type="password" className={`${inputClass} ${confirmPassword && confirmPassword !== newPassword ? 'border-red-400' : ''}`} placeholder="Repeat password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} disabled={loading} />
              </div>
              {error && <div className="flex items-center gap-2 bg-red-50 border border-red-100 px-4 py-3 rounded-xl text-red-600 text-sm">⚠️ {error}</div>}
              {success && <div className="flex items-center gap-2 bg-green-50 border border-green-100 px-4 py-3 rounded-xl text-green-700 text-sm">✅ {success}</div>}
              <button type="submit" disabled={loading || newPassword.length < 4 || newPassword !== confirmPassword} className={btnPrimary}>{loading ? '🔄 Resetting...' : 'Reset Password'}</button>
            </form>
            
            <button onClick={goBackToLogin} className="mt-6 text-center w-full text-amber-600 hover:text-amber-700 text-sm font-medium">← Back to login</button>
          </div>
        </div>
      </div>
    );
  }

  // SHOW USERNAME
  if (screen === 'show-username') {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "linear-gradient(135deg, #ecfdf5, #bbf7d0)" }}>
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden p-8 text-center">
          <h2 className="text-3xl font-bold text-stone-900 mb-4">Username Found</h2>
          <div className="bg-amber-50 border-2 border-dashed border-amber-300 rounded-lg py-6 px-8 mb-8">
            <p className="font-mono text-2xl font-bold text-amber-800 tracking-widest">{recoveredUsername}</p>
          </div>
          <button onClick={() => { setForm({...form, username: recoveredUsername}); goBackToLogin(); }} className={btnPrimary}>Sign In</button>
        </div>
      </div>
    );
  }

  // WORKER CONTACT ADMIN
  if (screen === 'worker-contact') {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "linear-gradient(135deg, #eff6ff, #bfdbfe)" }}>
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden p-8 text-center">
          <h2 className="text-3xl font-bold text-stone-900 mb-4">Contact Admin</h2>
          <p className="text-stone-600 text-sm mb-6">Worker accounts need admin help for password recovery.</p>
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6 text-sm text-left">
            <ul className="text-blue-700 space-y-2">
              <li>• Contact your workshop admin</li>
              <li>• Admin resets passwords in worker panel</li>
              <li>• Your username was assigned when you joined</li>
            </ul>
          </div>
          <button onClick={goBackToLogin} className={btnPrimary}>← Back</button>
        </div>
      </div>
    );
  }
}
